const tr = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Yükleniyor...',
    error: 'Hata',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    create: 'Oluştur',
    add: 'Ekle',
    remove: 'Kaldır',
    close: 'Kapat',
    confirm: 'Onayla',
    apply: 'Uygula',
    reset: 'Sıfırla',
    search: 'Ara',
    filter: 'Filtrele',
    clear: 'Temizle',
    back: 'Geri',
    next: 'İleri',
    previous: 'Önceki',
    submit: 'Gönder',
    update: 'Güncelle',
    refresh: 'Yenile',
    export: 'Dışa Aktar',
    import: 'İçe Aktar',
    download: 'İndir',
    upload: 'Yükle',
    print: 'Yazdır',
    copy: 'Kopyala',
    yes: 'Evet',
    no: 'Hayır',
    ok: 'Tamam',
    done: 'Tamamlandı',
    select: 'Seç',
    selectAll: 'Tümünü Seç',
    deselectAll: 'Tüm Seçimi Kaldır',
    noResults: 'Sonuç bulunamadı',
    noData: 'Veri mevcut değil',
    required: 'Zorunlu',
    optional: 'İsteğe bağlı',
    actions: 'İşlemler',
    details: 'Ayrıntılar',
    overview: 'Genel Bakış',
    summary: 'Özet',
    total: 'Toplam',
    all: 'Tümü',
    none: 'Hiçbiri',
    name: 'Ad',
    type: 'Tür',
    status: 'Durum',
    date: 'Tarih',
    time: 'Saat',
    description: 'Açıklama',
    notes: 'Notlar',
    comments: 'Yorumlar',
    category: 'Kategori',
    priority: 'Öncelik',
    nation: 'Ülke',
    country: 'Ülke',
    email: 'E-posta',
    phone: 'Telefon',
    address: 'Adres',
    location: 'Konum',
    coordinates: 'Koordinatlar',
    latitude: 'Enlem',
    longitude: 'Boylam',
    from: 'Kimden',
    to: 'Kime',
    createdAt: 'Oluşturulma',
    updatedAt: 'Güncellenme',
    createdBy: 'Oluşturan',
    modifiedBy: 'Değiştiren',
    active: 'Aktif',
    inactive: 'Pasif',
    enabled: 'Etkin',
    disabled: 'Devre dışı',
    showing: 'Gösterilen',
    of: '/',
    page: 'Sayfa',
    perPage: 'sayfa başına',
    rows: 'satır',
    items: 'öğe',
    results: 'sonuç',
    sortBy: 'Sıralama',
    ascending: 'Artan',
    descending: 'Azalan',
    viewAll: 'Tümünü Gör',
    viewDetails: 'Ayrıntıları Gör',
    goBack: 'Geri Dön',
    learnMore: 'Daha Fazla Bilgi',
    seeMore: 'Daha Fazla Gör',
    showMore: 'Daha Fazla Göster',
    showLess: 'Daha Az Göster',
    expandAll: 'Tümünü Genişlet',
    collapseAll: 'Tümünü Daralt',
    copied: 'Kopyalandı!',
    saved: 'Kaydedildi!',
    deleted: 'Silindi!',
    updated: 'Güncellendi!',
    created: 'Oluşturuldu!',
    success: 'Başarılı',
    warning: 'Uyarı',
    info: 'Bilgi',
    danger: 'Tehlike',
    unknown: 'Bilinmiyor',
    notAvailable: 'Yok',
    never: 'Hiçbir zaman',
    today: 'Bugün',
    yesterday: 'Dün',
    tomorrow: 'Yarın',
    now: 'Şimdi',
    ago: 'önce',
    justNow: 'az önce',
    minutesAgo: '{{count}}dk önce',
    hoursAgo: '{{count}}sa önce',
    daysAgo: '{{count}}g önce',
    monthsAgo: '{{count}}ay önce',
    id: 'Kimlik',
    version: 'Sürüm',
    language: 'Dil',
    theme: 'Tema',
    darkMode: 'Koyu Mod',
    lightMode: 'Açık Mod',
    failedToLoad: 'Veriler yüklenemedi',
    failedToSave: 'Kaydedilemedi',
    failedToDelete: 'Silinemedi',
    failedToUpdate: 'Güncellenemedi',
    confirmDelete: 'Bunu silmek istediğinizden emin misiniz?',
    confirmAction: 'Emin misiniz?',
    unsavedChanges: 'Kaydedilmemiş değişiklikleriniz var. Ayrılmak istediğinizden emin misiniz?',
    pageNotFound: '404 - Sayfa Bulunamadı',
    pageNotFoundDesc: 'Aradığınız sayfa mevcut değil.',
    backToDashboard: 'Panoya Dön',
    characters: 'karakter',
    maxCharacters: 'En fazla {{max}} karakter',
    remaining: '{{count}} kalan',
    selected: '{{count}} seçildi',
    of_total: '{{count}} / {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Pano',
    requests: 'Talepler',
    transports: 'Nakliyeler',
    myPatients: 'Hastalarım',
    statistics: 'İstatistikler',
    flow: 'Akış',
    resources: 'Resources',
    exercise: 'Tatbikat',
    administration: 'Yönetim',
    map: 'Harita',
    info: 'Bilgi',
    users: 'Kullanıcılar',
    assets: 'Araçlar',
    hubs: 'Merkezler',
    treatmentFacilities: 'Tedavi Tesisleri',
    patientImport: 'Hasta İçe Aktarma',
    assetTemplates: 'Araç Şablonları',
    dayTemplates: 'Gün Şablonları',
    announcementTicker: 'Duyuru Bandı',
    exerciseStatistics: 'Tatbikat İstatistikleri',
    settings: 'Ayarlar',
    auditLog: 'Denetim Günlüğü',
    exerciseControl: 'Tatbikat Kontrolü',
    dataSync: 'Veri Senkronizasyonu',
    documentation: 'Belgeler',
    support: 'Destek',
    about: 'Hakkında',
    assetContracts: 'Asset Contracts',
    notifications: 'Bildirimler',
    schedules: 'Tarifeler',
    capacityPlanning: 'Kapasite Planlaması',
    transportPlanning: 'Nakliye Planlaması',
    transportBooking: 'Nakliye Rezervasyonu',
    flowDiagram: 'Akış Diyagramı',
    changePassword: 'Şifre Değiştir',
    missions: 'Görevler',
    startPoints: 'Başlangıç Noktaları',
    hospital: 'Hastane',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Giriş',
    logout: 'Çıkış',
    logoutNow: 'Şimdi Çıkış Yap',
    loggingIn: 'Giriş yapılıyor...',
    loginFailed: 'Giriş başarısız',
    email: 'E-posta',
    password: 'Şifre',
    username: 'Kullanıcı Adı',
    enterEmail: 'E-posta adresinizi girin',
    enterPassword: 'Şifrenizi girin',
    enterUsername: 'Kullanıcı adınızı girin',
    forgotPassword: 'Şifrenizi mi unuttunuz?',
    forgotPasswordTitle: 'Şifremi Unuttum',
    forgotPasswordDesc: 'Kullanıcı adınızı ve e-posta adresinizi girin. Her ikisi de eşleşirse, yöneticilere şifrenizi sıfırlamaları için bildirim gönderilecektir.',
    requestPasswordReset: 'Şifre Sıfırlama Talebi',
    sending: 'Gönderiliyor...',
    backToLogin: 'Girişe Dön',
    pleaseWait: 'Lütfen tekrar denemeden önce bekleyin.',
    requestFailed: 'Talep başarısız',
    credentialsMatch: 'Kimlik bilgileri eşleşirse, yöneticilere bildirim gönderilmiştir.',
    forAccess: 'Erişim için lütfen sistem yöneticinizle iletişime geçin.',
    changePassword: 'Şifre Değiştir',
    currentPassword: 'Mevcut Şifre',
    newPassword: 'Yeni Şifre',
    confirmPassword: 'Şifreyi Onayla',
    passwordChanged: 'Şifre başarıyla değiştirildi',
    passwordMismatch: 'Şifreler eşleşmiyor',
    passwordTooShort: 'Şifre en az 8 karakter olmalıdır',
    changingPassword: 'Değiştiriliyor...',
    mustChangePassword: 'Devam etmeden önce şifrenizi değiştirmeniz gerekiyor.',
    sessionExpiring: 'Oturum Sona Eriyor',
    sessionExpireText: 'Oturumunuz <strong>{{time}}</strong> içinde sona erecek. Lütfen çalışmanızı kaydedin ve devam etmek için tekrar giriş yapın.',
    dismiss: 'Kapat',
    switchNation: 'Ülke Değiştir',
    returnTo: '{{nation}} ülkesine dön',
    viewingAs: 'Görüntüleme modu',
    loggedInAs: '{{nation}} olarak giriş yapıldı',
    trainingMode: 'YALNIZCA EĞİTİM AMAÇLIDIR',
    dedication: 'Mesleğe sevgi ve özveriyle oluşturulmuştur',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Sistem Yöneticisi',
    excon: 'Tatbikat Kontrolörü',
    eu: 'AB Koordinatörü',
    planner: 'Planlayıcı',
    hub: 'Merkez Yöneticisi',
    nation: 'Ülke',
    readOnly: 'Salt Okunur',
    systemAdmin: 'Sistem Yöneticisi',
    transportPlanner: 'Nakliye Planlayıcısı',
    systemRoles: 'Sistem Rolleri',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Taslak',
    underReview: 'İncelemede',
    published: 'Yayınlandı',
    underSelection: 'Seçimde',
    accepted: 'Kabul Edildi',
    planned: 'Planlandı',
    inTransit: 'Yolda',
    completed: 'Tamamlandı',
    closed: 'Kapatıldı',
    withdrawn: 'Geri Çekildi',
    pending: 'Beklemede',
    rejected: 'Reddedildi',
    cancelled: 'İptal Edildi',
    active: 'Aktif',
    inactive: 'Pasif',
    review: 'İnceleme',
    selection: 'Seçim',
    transit: 'Transit',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personel',
    material: 'Malzeme',
    equipment: 'Ekipman',
    other: 'Diğer',
    news: 'Haberler',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Rutin',
    priority: 'Öncelikli',
    urgent: 'Acil',
    immediate: 'Derhal',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Tren',
    ship: 'Gemi',
    aircraft: 'Uçak',
    bus: 'Otobüs',
    ambulance: 'Ambulans',
    drone: 'Drone',
    helicopter: 'Helikopter',
    ferry: 'Feribot',
    other: 'Diğer',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Pano',
    goodMorning: 'Günaydın',
    goodAfternoon: 'İyi günler',
    goodEvening: 'İyi akşamlar',
    lastLogin: 'Son giriş',
    infrastructure: 'Altyapı',
    transportAssets: 'Nakliye Araçları',
    treatmentFacilities: 'Tedavi Tesisleri',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Talep İstatistikleri',
    viewAllRequests: 'Tüm talepleri görüntüle',
    availableAssets: 'Mevcut Araçlar',
    seated: 'Oturarak',
    lying: 'Yatarak',
    intensive: 'Yoğun Bakım',
    notifications: 'Bildirimler',
    markAllRead: 'Tümünü okundu işaretle',
    noNotifications: 'Henüz bildirim yok',
    notifiedWhenActivity: 'Yeni bir etkinlik olduğunda bilgilendirileceksiniz',
    viewDetailsBtn: 'Ayrıntıları Gör',
    nationUsers: 'Ülke Kullanıcıları',
    user: 'Kullanıcı',
    roles: 'Roller',
    noUsersFound: 'Kullanıcı bulunamadı',
    participatingNations: 'Katılımcı Ülkeler',
    exerciseDisclaimer: 'Bu sistem yalnızca tatbikat amaçlıdır. Yalnızca simüle edilmiş tatbikat verileri girin. İş akışları tatbikat senaryosuna göre uyarlanmıştır ve gerçek prosedürlerden farklı olabilir. BT güvenliği ve veri koruma kuralları tamamen geçerlidir.',
    notConfigured: 'Yapılandırılmamış',
    requestCount: '{{count}} talep',
    clickToView: 'Görüntülemek için tıklayın',
    systemAdministration: 'Sistem Yönetimi',
    exerciseControlTitle: 'Tatbikat Kontrolü',
    euCoordination: 'AB Koordinasyonu',
    transportPlanningTitle: 'Nakliye Planlaması',
    hubManagement: 'Merkez Yönetimi',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Yeni Talep',
    myDrafts: 'Taslaklarım',
    pendingReview: 'İnceleme Bekleyen',
    activeTransports: 'Aktif Nakliyeler',
    myPatients: 'Hastalarım',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Talepler',
    newRequest: 'Yeni Talep',
    createRequest: 'Talep Oluştur',
    editRequest: 'Talebi Düzenle',
    requestDetail: 'Talep Ayrıntısı',
    requestId: 'Talep Kimliği',
    fromNation: 'Gönderen Ülke',
    toNation: 'Alan Ülke',
    requestingNation: 'Talep Eden Ülke',
    receivingNation: 'Alan Ülke',
    category: 'Kategori',
    urgency: 'Aciliyet',
    status: 'Durum',
    patients: 'Hastalar',
    patientCount: 'Hasta Sayısı',
    offers: 'Teklifler',
    offerCount: 'Teklif Sayısı',
    created: 'Oluşturulma',
    updated: 'Güncellenme',
    submittedBy: 'Gönderen',
    reviewedBy: 'İnceleyen',
    description: 'Açıklama',
    medicalDetails: 'Tıbbi Ayrıntılar',
    transportDetails: 'Nakliye Ayrıntıları',
    additionalInfo: 'Ek Bilgiler',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Kalkış Noktası',
    arrivalPoint: 'Varış Noktası',
    estimatedDeparture: 'Tahmini Kalkış',
    estimatedArrival: 'Tahmini Varış',
    submitForReview: 'İncelemeye Gönder',
    publish: 'Yayınla',
    startSelection: 'Seçimi Başlat',
    acceptOffer: 'Teklifi Kabul Et',
    markInTransit: 'Yolda Olarak İşaretle',
    markCompleted: 'Tamamlandı Olarak İşaretle',
    closeRequest: 'Talebi Kapat',
    withdrawRequest: 'Talebi Geri Çek',
    withdraw: 'Geri Çek',
    revertToDraft: 'Taslağa Döndür',
    deleteRequest: 'Talebi Sil',
    duplicateRequest: 'Talebi Çoğalt',
    createFollowUp: 'Konsolide Talep Oluştur',
    followUpRequest: 'Konsolide Talep',
    parentRequest: 'Orijinal Talep',
    childRequests: 'Konsolide Talepler',
    noRequests: 'Talep bulunamadı',
    noOffers: 'Henüz teklif yok',
    addPatient: 'Hasta Ekle',
    removePatient: 'Hastayı Kaldır',
    patientDetails: 'Hasta Ayrıntıları',
    contactPerson: 'İlgili Kişi',
    contactPhone: 'İletişim Telefonu',
    contactEmail: 'İletişim E-postası',
    specialRequirements: 'Özel Gereksinimler',
    medicalEquipment: 'Tıbbi Ekipman',
    accompaniment: 'Refakat',
    timeline: 'Zaman Çizelgesi',
    history: 'Geçmiş',
    addComment: 'Yorum Ekle',
    writeComment: 'Yorum yazın...',
    postComment: 'Yorumu Gönder',
    posting: 'Gönderiliyor...',
    noComments: 'Henüz yorum yok',
    coverageBar: 'Kapsam',
    covered: 'kapsanan',
    uncovered: 'kapsanmayan',
    filterByStatus: 'Duruma göre filtrele',
    filterByCategory: 'Kategoriye göre filtrele',
    filterByNation: 'Ülkeye göre filtrele',
    searchRequests: 'Talep ara...',
    confirmWithdraw: 'Bu talebi geri çekmek istediğinizden emin misiniz?',
    confirmDelete: 'Bu talebi silmek istediğinizden emin misiniz?',
    confirmPublish: 'Bu talebi yayınlamak istediğinizden emin misiniz? Tüm ülkeler tarafından görünür olacaktır.',
    confirmStartSelection: 'Seçimi başlatmak istediğinizden emin misiniz? Ülkeler teklif verebilecektir.',
    warningStartSelection: 'Seçimi başlatmak bu talebi tüm katılımcı ülkelere görünür kılacaktır. Bu talepteki hastalar için teklif gönderebileceklerdir. Bu işlem geri alınamaz.',
    warningMakeOffer: 'Bu teklifi göndererek ülkenizi önerilen yardımı sağlamaya taahhüt ediyorsunuz. Bu işlem talep eden ülkeyi ve tatbikat kontrolünü bilgilendirecektir.',
    saveDraft: 'Taslağı Kaydet',
    saving: 'Kaydediliyor...',
    saveAndSubmit: 'Kaydet ve Gönder',
    step: 'Adım {{number}}',
    generalInfo: 'Genel Bilgiler',
    patientInfo: 'Hasta Bilgileri',
    logisticsInfo: 'Lojistik Bilgileri',
    reviewSubmit: 'İncele ve Gönder',
    requestTitle: 'Talep Başlığı',
    requestDescription: 'Talep Açıklaması',
    numberOfPatients: 'Hasta Sayısı',
    typeOfAssistance: 'Yardım Türü',
    medicalTreatment: 'Tıbbi Tedavi',
    transportAssistance: 'Nakliye Yardımı',
    both: 'Her İkisi',
    treatmentOnly: 'Yalnızca Tedavi',
    transportOnly: 'Yalnızca Nakliye',
    validationErrors: 'Lütfen aşağıdaki hataları düzeltin:',
    fieldRequired: 'Bu alan zorunludur',
    selectExitHub: 'Bir çıkış merkezi seçin',
    createExitHub: 'Çıkış Merkezi Oluştur',
    backToRequests: 'Taleplere Dön',
    noRequestsFound: 'Talep bulunamadı',
    createFirstRequest: 'Başlamak için ilk talebinizi oluşturun',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Teklifler',
    createOffer: 'Teklif Oluştur',
    makeOffer: 'Teklif Ver',
    manageOffers: 'Teklifleri Yönet',
    offerDetail: 'Teklif Ayrıntısı',
    offerId: 'Teklif Kimliği',
    offeringNation: 'Teklif Veren Ülke',
    offerType: 'Teklif Türü',
    treatment: 'Tedavi',
    transport: 'Nakliye',
    combined: 'Birleşik',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Tedavi Teklifi',
    transportOffer: 'Nakliye Teklifi',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Hasta Seç',
    selectedPatients: 'Seçili Hastalar',
    patientSelection: 'Hasta Seçimi',
    offerConfiguration: 'Teklif Yapılandırması',
    reviewOffer: 'Teklifi İncele',
    submitOffer: 'Teklifi Gönder',
    submitting: 'Gönderiliyor...',
    acceptOffer: 'Teklifi Kabul Et',
    rejectOffer: 'Teklifi Reddet',
    withdrawOffer: 'Teklifi Geri Çek',
    noOffers: 'Mevcut teklif yok',
    noOffer: 'No Offer',
    offerStatus: 'Teklif Durumu',
    offerDate: 'Teklif Tarihi',
    transportAsset: 'Nakliye Aracı',
    departureDate: 'Kalkış Tarihi',
    arrivalDate: 'Varış Tarihi',
    treatmentFacility: 'Tedavi Tesisi',
    capacity: 'Kapasite',
    availableCapacity: 'Mevcut Kapasite',
    totalCapacity: 'Toplam Kapasite',
    selectAsset: 'Araç Seç',
    selectFacility: 'Tesis Seç',
    offerNotes: 'Teklif Notları',
    confirmAccept: 'Bu teklifi kabul etmek istediğinizden emin misiniz?',
    confirmReject: 'Bu teklifi reddetmek istediğinizden emin misiniz?',
    extendTransport: 'Nakliyeyi Uzat',
    transportExtension: 'Nakliye Uzatması',
    comparisonView: 'Karşılaştırma Görünümü',
    shortlist: 'Kısa Liste',
    addToShortlist: 'Kısa Listeye Ekle',
    removeFromShortlist: 'Kısa Listeden Çıkar',
    leaveConfirmTitle: 'Bu sayfadan ayrılsın mı?',
    leaveConfirmMessage: 'Kaydedilmemiş değişiklikleriniz var. Ayrılmak istediğinizden emin misiniz?',
    stayOnPage: 'Sayfada Kal',
    leavePage: 'Sayfadan Ayrıl',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Nakliyeler',
    missionDetail: 'Nakliye Ayrıntısı',
    missionId: 'Nakliye Kimliği',
    missionStatus: 'Nakliye Durumu',
    createMission: 'Nakliye Oluştur',
    overview: 'Genel Bakış',
    patientsTab: 'Hastalar',
    transportsTab: 'Nakliye Ayakları',
    treatmentTab: 'Tedavi',
    reviewTab: 'İnceleme',
    departure: 'Kalkış',
    arrival: 'Varış',
    origin: 'Çıkış',
    destination: 'Hedef',
    stops: 'Duraklar',
    addStop: 'Durak Ekle',
    removeStop: 'Durağı Kaldır',
    stopName: 'Durak Adı',
    stopType: 'Durak Türü',
    estimatedTime: 'Tahmini Süre',
    actualTime: 'Gerçek Süre',
    asset: 'Araç',
    driver: 'Sürücü',
    crew: 'Ekip',
    noMissions: 'Nakliye bulunamadı',
    completeMission: 'Nakliyeyi Tamamla',
    cancelMission: 'Nakliyeyi İptal Et',
    startTransport: 'Nakliyeyi Başlat',
    missionChain: 'Nakliye Zinciri',
    linkedMissions: 'Bağlantılı Nakliyeler',
    handover: 'Devir Teslim',
    handoverPoint: 'Devir Teslim Noktası',
    pickupPoint: 'Alış Noktası',
    dropoffPoint: 'Bırakış Noktası',
    searchTransports: 'Nakliye ara...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Hastalar',
    myPatients: 'Hastalarım',
    patientId: 'Hasta Kimliği',
    firstName: 'Ad',
    lastName: 'Soyad',
    dateOfBirth: 'Doğum Tarihi',
    age: 'Yaş',
    gender: 'Cinsiyet',
    male: 'Erkek',
    female: 'Kadın',
    other: 'Diğer',
    nationality: 'Uyruk',
    diagnosis: 'Tanı',
    condition: 'Durum',
    stable: 'Stabil',
    critical: 'Kritik',
    serious: 'Ciddi',
    treatmentNeeded: 'Tedavi Gerekli',
    allergies: 'Alerjiler',
    medications: 'İlaçlar',
    bloodType: 'Kan Grubu',
    weight: 'Ağırlık (kg)',
    infectious: 'Bulaşıcı',
    mentalHealth: 'Ruh Sağlığı',
    mobility: 'Hareketlilik',
    ambulatory: 'Yürüyebilen',
    wheelchair: 'Tekerlekli Sandalye',
    stretcher: 'Sedye',
    intensive: 'Yoğun Bakım',
    oxygenRequired: 'Oksijen Gerekli',
    ventilator: 'Ventilatör',
    medicalEscort: 'Tıbbi Refakat',
    noPatients: 'Hasta bulunamadı',
    patientDetails: 'Hasta Ayrıntıları',
    medicalHistory: 'Tıbbi Geçmiş',
    travelDocuments: 'Seyahat Belgeleri',
    passport: 'Pasaport',
    pseudonymizedId: 'Takma Kimlik',
    sensitiveData: 'Hassas Veriler',
    journey: 'Hasta Yolculuğu',
    assignedTo: 'Atanan',
    currentLocation: 'Mevcut Konum',
    importPatients: 'Hastaları İçe Aktar',
    exportPatients: 'Hastaları Dışa Aktar',
    seated: 'Oturarak',
    lying: 'Yatarak',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Kullanıcılar',
    createUser: 'Kullanıcı Oluştur',
    editUser: 'Kullanıcıyı Düzenle',
    deleteUser: 'Kullanıcıyı Sil',
    username: 'Kullanıcı Adı',
    displayName: 'Görünen Ad',
    email: 'E-posta',
    password: 'Şifre',
    role: 'Rol',
    roles: 'Roller',
    nation: 'Ülke',
    active: 'Aktif',
    lastLogin: 'Son Giriş',
    createdAt: 'Oluşturulma',
    isNation: 'Ülke',
    isEU: 'AB',
    isAdmin: 'Yönetici',
    isExcon: 'EXCON',
    isPlanner: 'Planlayıcı',
    isHub: 'Merkez',
    isReadOnly: 'Salt Okunur',
    noUsers: 'Kullanıcı bulunamadı',
    confirmDelete: 'Bu kullanıcıyı silmek istediğinizden emin misiniz?',
    resetPassword: 'Şifreyi Sıfırla',
    generatePassword: 'Şifre Oluştur',
    searchUsers: 'Kullanıcı ara...',
    userCreated: 'Kullanıcı başarıyla oluşturuldu',
    userUpdated: 'Kullanıcı başarıyla güncellendi',
    userDeleted: 'Kullanıcı başarıyla silindi',
    selectNation: 'Bir ülke seçin',
    mustChangePassword: 'Sonraki girişte şifre değiştirmeli',
    flagImage: 'Bayrak Görseli',
    exportUsers: 'Kullanıcıları Dışa Aktar',
    importUsers: 'Kullanıcıları İçe Aktar',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Araçlar',
    createAsset: 'Araç Oluştur',
    editAsset: 'Aracı Düzenle',
    deleteAsset: 'Aracı Sil',
    assetName: 'Araç Adı',
    assetType: 'Araç Türü',
    capacitySeated: 'Kapasite (Oturarak)',
    capacityLying: 'Kapasite (Yatarak)',
    capacityIntensive: 'Kapasite (Yoğun Bakım)',
    owner: 'Sahibi',
    operator: 'İşletmeci',
    baseLocation: 'Üs Konumu',
    range: 'Menzil',
    speed: 'Hız',
    noAssets: 'Araç bulunamadı',
    confirmDelete: 'Bu aracı silmek istediğinizden emin misiniz?',
    searchAssets: 'Araç ara...',
    assetCreated: 'Araç başarıyla oluşturuldu',
    assetUpdated: 'Araç başarıyla güncellendi',
    assetDeleted: 'Araç başarıyla silindi',
    exportAssets: 'Araçları Dışa Aktar',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Merkezler',
    startPoints: 'Başlangıç Noktaları',
    createHub: 'Merkez Oluştur',
    editHub: 'Merkezi Düzenle',
    deleteHub: 'Merkezi Sil',
    hubName: 'Merkez Adı',
    hubType: 'Merkez Türü',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Giriş Merkezi',
    airport: 'Havalimanı',
    seaport: 'Liman',
    railStation: 'Tren İstasyonu',
    roadPoint: 'Karayolu Noktası',
    ucpmClassification: 'UCPM Sınıflandırması',
    icaoCode: 'ICAO Kodu',
    iataCode: 'IATA Kodu',
    noHubs: 'Merkez bulunamadı',
    confirmDelete: 'Bu merkezi silmek istediğinizden emin misiniz?',
    searchHubs: 'Merkez ara...',
    nationAssignment: 'Ülke Ataması',
    assignNations: 'Ülkeleri Ata',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Tedavi Tesisleri',
    createFacility: 'Tesis Oluştur',
    editFacility: 'Tesisi Düzenle',
    deleteFacility: 'Tesisi Sil',
    facilityName: 'Tesis Adı',
    facilityType: 'Tesis Türü',
    hospitalName: 'Hastane Adı',
    bedCapacity: 'Yatak Kapasitesi',
    specialties: 'Uzmanlıklar',
    availableBeds: 'Mevcut Yataklar',
    totalBeds: 'Toplam Yatak',
    contactPerson: 'İlgili Kişi',
    noFacilities: 'Tedavi tesisi bulunamadı',
    confirmDelete: 'Bu tesisi silmek istediğinizden emin misiniz?',
    searchFacilities: 'Tesis ara...',
    hubNationAssignment: 'Merkez Ülke Ataması',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Tarifeler',
    createSchedule: 'Tarife Oluştur',
    editSchedule: 'Tarifeyi Düzenle',
    deleteSchedule: 'Tarifeyi Sil',
    scheduleName: 'Tarife Adı',
    scheduleType: 'Tarife Türü',
    recurring: 'Tekrarlayan',
    oneTime: 'Tek Seferlik',
    frequency: 'Sıklık',
    daily: 'Günlük',
    weekly: 'Haftalık',
    startDate: 'Başlangıç Tarihi',
    endDate: 'Bitiş Tarihi',
    departureTime: 'Kalkış Saati',
    arrivalTime: 'Varış Saati',
    stops: 'Duraklar',
    addStop: 'Durak Ekle',
    noSchedules: 'Tarife bulunamadı',
    bookings: 'Rezervasyonlar',
    timeline: 'Zaman Çizelgesi',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Bildirimler',
    markAllRead: 'Tümünü okundu işaretle',
    markAsRead: 'Okundu işaretle',
    markAsUnread: 'Okunmadı işaretle',
    noNotifications: 'Bildirim yok',
    viewAll: 'Tüm Bildirimleri Gör',
    settings: 'Bildirim Ayarları',
    emailNotifications: 'E-posta Bildirimleri',
    inAppNotifications: 'Uygulama İçi Bildirimler',
    notifyOn: 'Beni bilgilendir',
    requestCreated: 'Yeni Talep',
    requestPublished: 'Talep Yayınlandı',
    requestClosed: 'Talep Kapatıldı',
    requestCompleted: 'Talep Tamamlandı',
    commentAdded: 'Yeni Yorum',
    offerReceived: 'Teklif Alındı',
    offerAccepted: 'Teklif Kabul Edildi',
    statusChanged: 'Durum Değişti',
    selectionStarted: 'Seçim Başladı',
    missionCreated: 'Nakliye Oluşturuldu',
    missionStatusUpdated: 'Nakliye Güncellendi',
    transportPartnerNamed: 'Nakliye Ortağı',
    transportExtensionReceived: 'Nakliye Uzatması',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Ayarlar',
    general: 'Genel',
    system: 'Sistem',
    email: 'E-posta',
    sync: 'Senkronizasyon',
    security: 'Güvenlik',
    appearance: 'Görünüm',
    systemName: 'Sistem Adı',
    systemEmail: 'Sistem E-postası',
    maintenanceMode: 'Bakım Modu',
    readOnlyMode: 'Salt Okunur Modu',
    emailEnabled: 'E-posta Etkin',
    smtpHost: 'SMTP Sunucusu',
    smtpPort: 'SMTP Portu',
    smtpUser: 'SMTP Kullanıcısı',
    smtpPassword: 'SMTP Şifresi',
    senderEmail: 'Gönderen E-postası',
    senderName: 'Gönderen Adı',
    testEmail: 'Test E-postası Gönder',
    syncEnabled: 'Senkronizasyon Etkin',
    syncUrl: 'Senkronizasyon URL',
    syncApiKey: 'Senkronizasyon API Anahtarı',
    settingsSaved: 'Ayarlar başarıyla kaydedildi',
    helpdesk: 'Yardım Masası',
    helpdeskTitle: 'Yardım Masası Başlığı',
    helpdeskEmail: 'Yardım Masası E-postası',
    helpdeskPhone: 'Yardım Masası Telefonu',
    helpdeskInfo: 'Yardım Masası Bilgisi',
    realLifeSupport: 'Gerçek Yaşam Desteği',
    trainingMode: 'Eğitim Modu',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Denetim Günlükleri',
    action: 'İşlem',
    user: 'Kullanıcı',
    target: 'Hedef',
    details: 'Ayrıntılar',
    timestamp: 'Zaman Damgası',
    ipAddress: 'IP Adresi',
    noLogs: 'Denetim günlüğü bulunamadı',
    searchLogs: 'Günlüklerde ara...',
    filterByAction: 'İşleme göre filtrele',
    filterByUser: 'Kullanıcıya göre filtrele',
    exportLogs: 'Günlükleri Dışa Aktar',
    exportCsv: 'CSV Olarak Dışa Aktar',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Tatbikat Kontrolü',
    currentDay: 'Mevcut Gün',
    exerciseDay: 'Tatbikat Günü',
    nextDay: 'Sonraki Gün',
    previousDay: 'Önceki Gün',
    resetExercise: 'Tatbikatı Sıfırla',
    startExercise: 'Tatbikatı Başlat',
    endExercise: 'Tatbikatı Bitir',
    dayReset: 'Gün Sıfırlama',
    confirmReset: 'Tatbikat gününü sıfırlamak istediğinizden emin misiniz? Bu, mevcut günün tüm verilerini silecektir.',
    resetInProgress: 'Sıfırlama devam ediyor...',
    maintenanceMode: 'Bakım Modu',
    enableMaintenance: 'Bakımı Etkinleştir',
    disableMaintenance: 'Bakımı Devre Dışı Bırak',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Veri Senkronizasyonu',
    syncStatus: 'Senkronizasyon Durumu',
    lastSync: 'Son Senkronizasyon',
    pendingItems: 'Bekleyen Öğeler',
    syncNow: 'Şimdi Senkronize Et',
    syncing: 'Senkronize ediliyor...',
    syncSuccess: 'Senkronizasyon başarıyla tamamlandı',
    syncFailed: 'Senkronizasyon başarısız',
    outbox: 'Giden Kutusu',
    inbox: 'Gelen Kutusu',
    configuration: 'Yapılandırma',
    targetUrl: 'Hedef URL',
    apiKey: 'API Anahtarı',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Harita',
    layers: 'Katmanlar',
    requests: 'Talepler',
    hubs: 'Merkezler',
    facilities: 'Tesisler',
    routes: 'Rotalar',
    showAll: 'Tümünü Göster',
    hideAll: 'Tümünü Gizle',
    zoomIn: 'Yakınlaştır',
    zoomOut: 'Uzaklaştır',
    resetView: 'Görünümü Sıfırla',
    satellite: 'Uydu',
    terrain: 'Arazi',
    offline: 'Çevrimdışı',
    online: 'Çevrimiçi',
    tilesOffline: 'Harita karoları yerel olarak sunuluyor',
    tilesOnline: 'Harita karoları çevrimiçi sunuculardan yükleniyor',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'İstatistikler',
    overview: 'Genel Bakış',
    requestsByStatus: 'Duruma Göre Talepler',
    requestsByCategory: 'Kategoriye Göre Talepler',
    requestsByNation: 'Ülkeye Göre Talepler',
    offersByStatus: 'Duruma Göre Teklifler',
    patientsByCondition: 'Duruma Göre Hastalar',
    transportsByStatus: 'Duruma Göre Nakliyeler',
    timeline: 'Zaman Çizelgesi',
    totalRequests: 'Toplam Talep',
    totalOffers: 'Toplam Teklif',
    totalPatients: 'Toplam Hasta',
    totalTransports: 'Toplam Nakliye',
    averageResponseTime: 'Ortalama Yanıt Süresi',
    completionRate: 'Tamamlanma Oranı',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Tatbikat İstatistikleri',
    overview: 'Genel Bakış',
    byCategory: 'Kategoriye Göre',
    byNation: 'Ülkeye Göre',
    byDay: 'Güne Göre',
    totalPatientsMoved: 'Toplam Taşınan Hasta',
    totalRequestsProcessed: 'Toplam İşlenen Talep',
    averageProcessingTime: 'Ortalama İşlem Süresi',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Akış Diyagramı',
    sankey: 'Sankey',
    nodeGraph: 'Düğüm Grafiği',
    refresh: 'Yenile',
    noData: 'Akış verisi mevcut değil',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Hakkında',
    version: 'Sürüm',
    systemInfo: 'Sistem Bilgisi',
    buildDate: 'Yapım Tarihi',
    environment: 'Ortam',
    description: 'ARCOS — Gelişmiş Talep İletişim Sistemi',
    subtitle: 'Kaza Yardımı ve Tıbbi Operasyonlar',
    whatIsArcos: 'ARCOS nedir? – Tatbikat katılımcıları için açıklama',
    arcosDesc1: 'ARCOS, bu tatbikatta katılımcı aktörler arasındaki uluslararası iletişim, talepler ve koordinasyon süreçlerini desteklemek ve yapılandırmak için kullanılan dijital bir araçtır.',
    arcosDesc2: 'ARCOS, bu sistemlerin temel prensiplerinin basitleştirilmiş, tatbikata yönelik bir temsilini sunar.',
    arcosUsedFor: 'Tatbikat sırasında ARCOS tipik süreçleri temsil etmek için kullanılır:',
    arcosUsedForItem1: 'yardım taleplerinin sunulması ve yönetilmesi,',
    arcosUsedForItem2: 'diğer uluslardan destek tekliflerinin koordinasyonu ve yanıtlanması,',
    arcosUsedForItem3: 'taleplerin durum ve ilerlemesinin takibi,',
    arcosUsedForItem4: 've basitleştirilmiş taşıma veya tahliye iş akışlarının temsili.',
    arcosDesc3: 'ARCOS\'taki iş akışları bilinçli olarak basitleştirilmiş ve tatbikatın eğitim hedeflerine uyarlanmıştır.',
    arcosDesc4: 'ARCOS\'un amacı mükemmel veya eksiksiz bir gerçek dünya sistemi simüle etmek değildir.',
    arcosDesc5: 'Bazı unsurlar bildiğiniz gerçek prosedürlerden farklıysa, bu beklenen bir durumdur.',
    facilitatedBy: 'MMCC-E tarafından desteklenmektedir',
    dhcInitiative: 'Digital Health Corner (DHC) ortak bir girişimdir:',
    dhcAuthor1: 'Sven Giegerich — Alman Silahlı Kuvvetleri',
    dhcAuthor2: 'Mohamad Haji — Belçika Savunması',
    dhcConviction: 'Tutkunun pragmatizmle buluştuğu yerde inovasyonun geliştiği inancından doğmuştur.',
    dhcInspired: 'MMCC-E\'nin başlattığı kıvılcımdan ilham alarak basit ama etkili çözümler yaratmaya koyulduk.',
    dhcLove: 'Bunu işimizi sevdiğimiz ve dijital fikirlerin askeri sağlık alanında iş birliğini dönüştürebileceğine inandığımız için yapıyoruz.',
    dhcOpen: 'DHC açık bir platformdur: hiyerarşilerden bağımsız, fikirlere açık, merak ve iş birliği ruhuyla yönlendirilir.',
    dhcClosing: 'Digital Health Corner – merakın iş birliğiyle buluştuğu yer.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Belgeler',
    gettingStarted: 'Başlarken',
    userGuide: 'Kullanıcı Kılavuzu',
    faq: 'SSS',
    troubleshooting: 'Sorun Giderme',
    apiReference: 'API Referansı',
    downloadTemplate: 'Şablonu İndir',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Hasta İçe Aktarma',
    uploadFile: 'Dosya Yükle',
    selectFile: 'Dosya Seç',
    preview: 'Önizleme',
    importNow: 'Şimdi İçe Aktar',
    importing: 'İçe aktarılıyor...',
    importSuccess: '{{count}} hasta başarıyla içe aktarıldı',
    importFailed: 'İçe aktarma başarısız',
    downloadTemplate: 'Şablonu İndir',
    dragDrop: 'Dosyayı buraya sürükleyip bırakın veya seçmek için tıklayın',
    supportedFormats: 'Desteklenen formatlar: XLSX, XLS, CSV',
    rowsFound: '{{count}} satır bulundu',
    validRows: '{{count}} geçerli satır',
    invalidRows: '{{count}} geçersiz satır',
    duplicateRows: '{{count}} yinelenen satır',
    previewData: 'Verileri Önizle',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Nakliye Planlaması',
    planRoute: 'Rota Planla',
    routeBuilder: 'Rota Oluşturucu',
    addWaypoint: 'Ara Nokta Ekle',
    removeWaypoint: 'Ara Noktayı Kaldır',
    estimatedDuration: 'Tahmini Süre',
    distance: 'Mesafe',
    selectVehicle: 'Araç Seç',
  },

  transportBooking: {
    title: 'Nakliye Rezervasyonu',
    bookTransport: 'Nakliye Rezervasyonu Yap',
    availableSlots: 'Mevcut Yerler',
    bookingConfirmed: 'Rezervasyon Onaylandı',
    cancelBooking: 'Rezervasyonu İptal Et',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Kapasite Planlaması',
    totalCapacity: 'Toplam Kapasite',
    usedCapacity: 'Kullanılan Kapasite',
    availableCapacity: 'Mevcut Kapasite',
    utilizationRate: 'Kullanım Oranı',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Araç Şablonları',
    dayTemplates: 'Gün Şablonları',
    createTemplate: 'Şablon Oluştur',
    editTemplate: 'Şablonu Düzenle',
    deleteTemplate: 'Şablonu Sil',
    templateName: 'Şablon Adı',
    applyTemplate: 'Şablonu Uygula',
    noTemplates: 'Şablon bulunamadı',
    confirmDelete: 'Bu şablonu silmek istediğinizden emin misiniz?',
    confirmApply: 'Bu şablonu uygulamak istediğinizden emin misiniz? Mevcut veriler üzerine yazılacaktır.',
    exportTemplates: 'Şablonları Dışa Aktar',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Duyuru Bandı',
    createAnnouncement: 'Duyuru Oluştur',
    editAnnouncement: 'Duyuruyu Düzenle',
    deleteAnnouncement: 'Duyuruyu Sil',
    message: 'Mesaj',
    startTime: 'Başlangıç Saati',
    endTime: 'Bitiş Saati',
    active: 'Aktif',
    noAnnouncements: 'Duyuru yok',
    confirmDelete: 'Bu duyuruyu silmek istediğinizden emin misiniz?',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Ara...',
      noResults: 'Sonuç bulunamadı',
      showing: '{{total}} öğeden {{from}} ile {{to}} arası gösteriliyor',
      rowsPerPage: 'Sayfa başına satır',
      previousPage: 'Önceki sayfa',
      nextPage: 'Sonraki sayfa',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Onayla',
      cancel: 'İptal',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Kaydedilmemiş Değişiklikler',
      message: 'Kaydedilmemiş değişiklikleriniz var. Bu sayfadan ayrılmak istediğinizden emin misiniz?',
      stay: 'Sayfada Kal',
      leave: 'Sayfadan Ayrıl',
    },
    // EmptyState
    emptyState: {
      noData: 'Veri mevcut değil',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Bir hata oluştu',
      message: 'Beklenmeyen bir hata oluştu. Lütfen sayfayı yenilemeyi deneyin.',
      retry: 'Tekrar Dene',
    },
    // ExportButton
    exportButton: {
      export: 'Dışa Aktar',
      exporting: 'Dışa aktarılıyor...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Yazdır',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Taslak',
      review: 'İnceleme',
      published: 'Yayınlandı',
      selection: 'Seçim',
      inTransit: 'Yolda',
      completed: 'Tamamlandı',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Çevrimiçi Örnek',
      message: 'Salt okunur modu. Veriler birincil sunucudan senkronize edilmektedir.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Görüntüleme modu',
      loggedInAs: '{{nation}} olarak giriş yapıldı',
      returnTo: '{{nation}} ülkesine dön',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Sayfa, talep, nakliye ara...',
      searching: 'Aranıyor...',
      noResults: '"{{query}}" için sonuç bulunamadı',
      navigate: 'Git',
      select: 'Seç',
      close: 'Kapat',
      pages: {
        dashboard: 'Pano',
        requests: 'Talepler',
        transports: 'Nakliyeler',
        map: 'Harita',
        myPatients: 'Hastalarım',
        flowDiagram: 'Akış Diyagramı',
        statistics: 'İstatistikler',
        assets: 'Araçlar',
        startPoints: 'Başlangıç Noktaları / Merkezler',
        treatmentFacilities: 'Tedavi Tesisleri',
        users: 'Kullanıcılar',
        settings: 'Ayarlar',
        auditLogs: 'Denetim Günlükleri',
        exerciseControl: 'Tatbikat Kontrolü',
        dataSync: 'Veri Senkronizasyonu',
        patientImport: 'Hasta İçe Aktarma',
        notifications: 'Bildirimler',
        documentation: 'Belgeler',
      },
      actions: {
        importPatientsJson: 'Hastalar İçe Aktar (JSON)',
        importPatientsExcel: 'Hastalar İçe Aktar (Excel)',
        importUsers: 'Kullanıcılar İçe Aktar (Excel)',
        importAssetTemplates: 'Varlık Şablonları İçe Aktar (Excel)',
        importDayTemplates: 'Gün Şablonu Girişleri İçe Aktar (Excel)',
        exportRequests: 'Talepler Dışa Aktar (Excel)',
        exportPatients: 'Hastalar Dışa Aktar (Excel)',
        exportUsers: 'Kullanıcılar Dışa Aktar (Excel)',
        exportCredentials: 'Kimlik Bilgileri Dışa Aktar (PDF)',
        exportAuditExcel: 'Denetim Günlüğü Dışa Aktar (Excel)',
        exportAuditPdf: 'Denetim Günlüğü Dışa Aktar (PDF)',
        pagePatientImport: 'Hasta içe aktarma sayfası',
        pageRequestDetail: 'Talep detay sayfası',
        pageUsers: 'Kullanıcı yönetimi sayfası',
        pageAssetTemplates: 'Varlık şablonları sayfası',
        pageDayTemplates: 'Gün şablonları sayfası',
        pageRequests: 'Talepler listesi sayfası',
        pageAuditLogs: 'Denetim günlüğü sayfası',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Oturum Sona Eriyor',
      message: 'Oturumunuz <strong>{{time}}</strong> içinde sona erecek. Lütfen çalışmanızı kaydedin ve devam etmek için tekrar giriş yapın.',
      dismiss: 'Kapat',
      logoutNow: 'Şimdi Çıkış Yap',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: '4 saat dilimi seçin',
      configure: 'Saat dilimlerini yapılandır',
      reset: 'Sıfırla',
      apply: 'Uygula',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Konum Seç',
      latitude: 'Enlem',
      longitude: 'Boylam',
      clickToSelect: 'Konum seçmek için haritaya tıklayın',
    },
    // Modal
    modal: {
      close: 'Kapat',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Ana Sayfa',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Sistem Bakımı',
    message: 'Sistem bir sonraki tatbikat günü için sıfırlanıyor. Lütfen işlem tamamlanana kadar bekleyin.',
    autoRefresh: 'Sistem tekrar kullanılabilir olduğunda bu sayfa otomatik olarak yenilenecektir.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'En az 10 karakter',
    uppercase: '1 büyük harf',
    lowercase: '1 küçük harf',
    digit: '1 rakam',
    special: '1 özel karakter',
  },
};

export default tr;
